import React from 'react';
import { useTranslation } from 'react-i18next';
import Contact from "../components/sections/Contact";
import {contactMeta} from "../constants/meta";
import Meta from "../components/common/Helmet";

const ContactPage = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Meta
        title={contactMeta.title}
        description={contactMeta.description}
        canonical={contactMeta.canonical}
        keywords={contactMeta.keywords}
        ogTitle={contactMeta.title}
        ogDescription={contactMeta.description}
      />
      <div className="contact-box h-svh overflow-hidden">
        <div className="w-full h-svh overflow-hidden bg-gradient-to-r from-black to-transparent flex flex-col md:flex-row items-center justify-between  text-white relative">
          <div className="md:w-theme-container w-mobile-container mx-auto">
            <div className="md:w-full z-10">
              <h2 className="text-3xl md:text-4xl font-semibold leading-loose">
                {t('common.buildYourDreamProject')} <br />
                {t('common.togetherWithExperts')} <br /> <br />
                {t('common.deliveredIn')} <span className="text-blue-500">{t('common.ninetyDays')}</span> {t('common.orLess')} !
              </h2>
              <p className="mt-4 text-sm md:text-base">
                {t('common.getStartedDescription')}
              </p>
              <a
                href="tel:+97142829613"
                className="w-[180px] mt-6 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-full flex items-center space-x-2 transition">
                  <span>{t('common.contactNow')} !</span>
                  <span className="text-lg"> → </span>
              </a>
            </div>
            <div className="md:w-1/2 bg-fuchsia-800 mt-8 md:mt-0 relative">
              {/* Background image is via CSS .get-started-box */}
              <div className="absolute inset-0 bg-gradient-to-l from-black/70 to-transparent rounded-xl"></div>
            </div>
          </div>
        </div>
      </div>
      <Contact />
    </div>
  );
};

export default ContactPage;
